import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  currentData: {
    notesImages: [],
  },
  all: [],
  editMode: false,
  total_pages: 1,
  search: [],
  searchValue: "",
  currentId: 0,
  images: [],
  viewMode: 1,
};

const templates = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TEMPLATE_DATA:
      return {
        ...state,
        currentData: {
          ...state.currentData,
          ...action.payload,
        },
      };

    case actionTypes.CLEAR_TEMPLATE_DATA:
      return { ...state, currentData: { notesImages: [] } };

    case actionTypes.ADD_TEMPLATE:
      return {
        ...state,
        all: [...state.all, action.payload],
      };

    case actionTypes.SET_ALL_TEMPLATE:
      return {
        ...state,
        all: [...action.payload.results],
        total_pages: action.payload.total_pages,
      };

    case actionTypes.GET_TEMPLATE_BYID:
      const templates = [...state?.all];
      const template = templates.find(
        ({ id }) => id === parseInt(action.payload)
      );

      return {
        ...state,
        currentData: { notesImages: [], ...template },
      };

    case actionTypes.UPDATE_TEMPLATE_BYID:
      let items = [...state?.all];
      let replaceIndex = items
        .map(item => {
          return item.id;
        })
        .indexOf(action.payload.id);
      items[replaceIndex] = action.payload;
      return { ...state, all: [...items] };

    case actionTypes.SET_EDIT_MODE:
      return { ...state, editMode: true };

    case actionTypes.CLEAR_EDIT_MODE:
      return { ...state, editMode: false };

    case actionTypes.REMOVE_TEMPLATE_BYID:
      let allitems = [...state?.all];
      let removeIndex = allitems
        .map(item => {
          return item.id;
        })
        .indexOf(action.payload);

      allitems.splice(removeIndex, 1);
      return { ...state, all: [...allitems] };

    case actionTypes.EMPTY_TEMPLATE_DATA:
      return {
        ...state,
        all: [],
        total_pages: 1,
        search: undefined,
        searchValue: undefined,
      };

    case actionTypes.SEARCH_TEMPLATE_DATA:
      return {
        ...state,
        searchValue: action.payload.searchValue,
        total_pages: action.payload.total_pages,
      };

    case actionTypes.SET_CURRENT_ID:
      return {
        ...state,
        currentId: action.id,
      };

    case actionTypes.SET_VIEW_MODE:
      return {
        ...state,
        viewMode: action.id,
      };

    case actionTypes.SET_SCREENSHOTS:
      return {
        ...state,
        images: [...state.images, action.payload],
      };

    case actionTypes.CLEAR_SCREENSHOTS:
      return {
        ...state,
        images: [],
      };

    case actionTypes.SET_IMAGES_INSIDE_NOTES:
      return {
        ...state,
        currentData: {
          ...state.currentData,
          notesImages: [...state.currentData.notesImages, action.payload],
        },
      };

    case actionTypes.REMOVE_IMAGES_FROM_NOTES: {
      const images = [...state.currentData.notesImages];

      const updatedImages = images.filter((_, i) => i !== action.payload);

      return {
        ...state,
        currentData: {
          ...state.currentData,
          notesImages: updatedImages,
        },
      };
    }
    default:
      return state;
  }
};

export default templates;
